export default "__VITE_ASSET__CSGWeGHF__"